<template>
  <div class="package-list">
    <div class="package-grid">
      <PackageCard
        v-for="pkg in packages"
        :key="pkg.productId"
        :package="pkg"
        :is-selected="selectedId === pkg.productId"
        :type="type"
        @select="handlePackageSelect"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { VipPackage, PagePackage } from '~/stores/pay'

interface Props {
  packages: (VipPackage | PagePackage)[]
  selectedId: string | null
  type: 'vip' | 'page'
}

defineProps<Props>()

const emit = defineEmits<{
  select: [pkg: VipPackage | PagePackage]
}>()

const handlePackageSelect = (pkg: VipPackage | PagePackage) => {
  emit('select', pkg)
}
</script>

<style scoped lang="scss">
.package-list {
  width: 100%;
}

.package-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}
</style>
